<template>
    <div>
        <section>
            <section class="section">
                <div class="container is-fluid">
                    <h3 class="title">{{ $t("editJob.title", { jobName: job.name }) }}</h3>

                    <div class="columns">
                        <div class="column">
                            <div class="field">
                                <label class="label">{{ $t("misc.name") }}</label>
                                <div class="control">
                                    <input class="input" v-model="job.name" type="text"
                                        :placeholder="$t('editJob.jobNamePlaceholder')">
                                </div>
                            </div>
                        </div>
                    </div>

                    <UnitsField :units="allUnits" ref="unitsField" />

                    <FrequencyField ref="frequencyField" />

                    <div class="field s-b-padding">
                        <label class="label">{{ $t("misc.mailtoHeader") }}</label>
                        <div class="control">
                            <input class="input" v-model="job.mailto" type="email"
                                :placeholder="$t('editJob.jobEmailPlaceholder')">
                        </div>
                    </div>

                    <hr />
                    <b-button @click="updateJob()" class="is-primary">
                        {{ $t("misc.save") }}
                    </b-button>
                </div>
            </section>
        </section>
    </div>
</template>

<script>

const axios = require('axios');

import UnitsField from "@/components/fields/UnitsField.vue"
import FrequencyField from "@/components/fields/FrequencyField.vue"

export default {
    name: "EditJob",
    components: {
        UnitsField,
        FrequencyField
    },
    data: function () {
        return {
            job: {
                name: "",
                mailto: "",
                units: [],
                frequency: ""
            },
            api: axios.create({
                baseURL: process.env.VUE_APP_JOBS_API_ROOT,
                headers: { Authorization: `Bearer ${localStorage.backendToken}` }
            }),
            allUnits: []
        }
    },
    methods: {
        updateJob() {
            this.job.frequency = this.$refs.frequencyField.timeInterval;
            this.job.units = this.$refs.unitsField.getChosenUnits();

            let validUnits = this.job.units.length > 0;

            if (!validUnits) {
                this.$buefy.toast.open({
                    message: this.$t("misc.formErrors"),
                    type: 'is-danger'
                });

                return;
            }

            let editJobView = this;
            let jobData = {
                name: this.job.name,
                mailto: this.job.mailto,
                frequency: this.job.frequency,
                units: this.job.units
            }

            this.api.post(`update-job/${this.job.id}`, jobData)
                .then(function (response) {
                    if (response.status == 200) {
                        editJobView.$buefy.toast.open({
                            message: editJobView.$t("editJob.saved"),
                            type: 'is-success'
                        });

                        editJobView.$router.push({ name: 'dashboard' });
                    } else {
                        editJobView.$buefy.toast.open({
                            message: this.$t("misc.genericError"),
                            type: 'is-danger'
                        })
                    }
                });
        },
        fetchUnits() {
            let editView = this;

            this.api.get("units").then(function (response) {
                editView.allUnits = response.data.units;
                editView.$refs.unitsField.setSelectedUnits(editView.job.units);
            });
        }
    },
    mounted: function () {
        this.job = this.$route.params.job;
        this.$refs.frequencyField.setTimeInterval(this.job.frequency);

        this.fetchUnits();
    },
};

</script>

<style scoped>
@media only screen and (max-width: 768px) {
    .button {
        width: 100%;
    }
}
</style>